import * as React from 'react';
import * as _ from 'underscore';

export interface ITypeNameElement {
    type: string | number;
    name: string;
}

export interface ISelectFieldOptions {
    source?: any[];
    values?: any[];
    display?: string[];
    tooltips?: string[];
    listSize?: number;
    readOnly?: boolean;
}

export default function SelectField(props: {
    value?: string;
    allowNull?: boolean;
    nullOptionTitle?: string;
    disabled?: boolean;
    readOnly?: boolean;
    listSize?: number;
    tooltip?: string;
    children?: React.ReactNode;
    options?: ISelectFieldOptions;

    onChange?(value: string): void;
    onBlur?(value: string): void;
    onFocus?(value: string): void;
}) {
    const controlRef = React.useRef<HTMLSelectElement>(null);

    const handleOnBlur = (e) => {
        const value = controlRef.current.value;

        if (props.onBlur != null) {
            props.onBlur(value);
        }
    };

    const handleOnFocus = (e) => {
        const value = controlRef.current.value;

        if (typeof props.onFocus === 'function') {
            props.onFocus(value);
        }
    };

    const getValues = (): any[] => {
        return props.options != null ? props.options.values : null;
    };

    const handleOnChange = (e) => {
        const value = controlRef.current.value;

        if (typeof props.onChange === 'function') {
            let result = value;

            if (value !== '') {
                if (props.children == null) {
                    const source = props.options != null ? props.options.source : null;

                    if (source != null) {
                        const values = getValues();

                        if (values != null) {
                            const index = _.indexOf(values, value);

                            result = source[index];
                        } else {
                            result = null;
                        }
                    }
                }
            } else if (props.allowNull === true) {
                result = null;
            }

            props.onChange(result);
        }
    };

    const options = props.options;

    let value = props.value || '';

    if (typeof value !== 'string') {
        value = (value as any).toString();
    }

    let elements: any[];

    if (props.children == null) {
        const values = getValues();

        if (values != null) {
            const display = options != null ? options.display : null;
            const tooltips = options != null ? options.tooltips : null;

            elements = _.map(values, (value, i) => {
                const text = display != null && display[i] != null ? display[i] : value;
                const tooltip = tooltips != null && tooltips[i] != null && tooltips[i] !== '' ? tooltips[i] : ''; //LL: 08.08.18: "" or null ?

                return (
                    <option key={i} value={value} title={tooltip}>
                        {text}
                    </option>
                );
            });
        }
    } else {
        elements = Array.isArray(props.children) ? props.children : [props.children];
    }

    let nullElement: React.JSX.Element;

    if (props.allowNull === true && elements != null && elements.length > 0) {
        nullElement = (
            <option key={'null value'} value={''}>
                {props.nullOptionTitle}
            </option>
        );
    }

    const listSize = props.listSize || (options && options.listSize);

    let selectClass = 'form-control';

    if (listSize > 1) {
        selectClass += ' format-list';
    }

    return (
        <div className="select-field">
            <select
                title={props.tooltip}
                className={selectClass}
                ref={controlRef}
                value={value}
                disabled={props.disabled || props.readOnly || options?.readOnly}
                tabIndex={0}
                size={listSize}
                onFocus={handleOnFocus}
                onBlur={handleOnBlur}
                onChange={handleOnChange}
            >
                {nullElement}
                {elements}
            </select>
        </div>
    );
}

export function createSelectFieldOptions(elements: ITypeNameElement[]) {
    if (elements != null && elements.length > 0) {
        return _.map(elements, (element, index) => {
            return (
                <option key={index.toString()} value={element.type != null ? element.type.toString() : element.type}>
                    {element.name}
                </option>
            );
        });
    } else {
        return null;
    }
}
